import React from 'react';
import { store } from 'react-notifications-component';
import { IoIosClose } from 'react-icons/io';

import { PRIMARY_COLOR } from '../../appearance/Colors';

function GoToFolderNotification({ toFolder, actionClick, title, actionTitle, notificationId, icon }) {
    // if (progress > 0) {
    //     setTimeout(() => {
    //         setProgress(progress - 20);
    //     }, 10);
    // } else {
    //     setProgress(100);
    // }

    return (
        <div
            className="luckynote-toast luckynote-toast--clickable"
            onClick={() => {
                // close(key);
                console.log('go to this folder', toFolder);
                store.removeNotification(notificationId);
                if (actionClick) {
                    actionClick();
                }
            }}
        >
            <div className="luckynote-toast__row">
                <div className="luckynote-toast__icon">
                    {icon}
                </div>
                {/* <ProgressRing radius={60} stroke={4} progress={progress} /> */}
                <div className="luckynote-toast__body">
                    <div className="luckynote-toast__copy">
                        <div className="luckynote-toast__title">{title}</div>
                        <span className="luckynote-toast__description">{actionTitle}</span>
                    </div>
                    <div className="luckynote-toast__spacer"></div>
                    {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
                        <IoIosArrowForward size={20}></IoIosArrowForward>
                    </div> */}
                </div>
            </div>
            <div
                className="luckynote-toast__floating-close"
                onClick={e => {
                    e.stopPropagation();
                    store.removeNotification(notificationId);
                }}
            >
                <IoIosClose color={PRIMARY_COLOR} size={18} />
            </div>
        </div>
    );
}

export default GoToFolderNotification;
